import { Dispatch } from 'react';

import { TabType } from './types';

import { useEditPageContext } from 'components/shared/CRUD/components/InnerPage/EditPage';

import CapPlanTab from './sections/CapPlanTab';
import DeviatingTab from './sections/DeviatingTab';
import ExtraHoursTab from './sections/ExtraHoursTab';
import GeneralTab from './sections/GeneralTab';
import LeaveTab from './sections/LeaveTab';

type SwitcherProps = {
  currentTab: TabType;
  setCurrentSchema: Dispatch<any>;
};

const TabSwitcher = ({ currentTab, setCurrentSchema }: SwitcherProps) => {
  const { isEditable } = useEditPageContext();

  switch (currentTab) {
    case TabType.GENERAL:
      return (
        <GeneralTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.LEAVE:
      return (
        <LeaveTab setCurrentSchema={setCurrentSchema} isEditable={isEditable} />
      );
    case TabType.EXTRA_HOURS:
      return (
        <ExtraHoursTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.CAP_PLAN:
      return (
        <CapPlanTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.DEVIATING:
      return (
        <DeviatingTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    default:
      return <div />;
  }
};

export default TabSwitcher;
